import {
    BODY_LG_LG_MEDIUM_STYLES,
    BODY_SM_SM_BOLD_STYLES,
    BODY_SM_SM_STYLES,
    BODY_XS_XS_MEDIUM_STYLES,
} from '@constants/text.ts';
import styled from 'styled-components';

// task preview START
const getSelectedRatingBackground = (scaleSize: number, ratingIndex: number): string => {
    if (scaleSize === 2) {
        return ratingIndex === 0 ? 'var(--colors-red-450, #E14B53)' : 'var(--colors-green-450, #1B8156)';
    }

    const fiveScaleBackgrounds = [
        'var(--colors-red-450, #E14B53)',
        'var(--colors-red-450, #E14B53)',
        'var(--colors-grey-450, #828080)',
        'var(--colors-green-450, #1B8156)',
        'var(--colors-green-450, #1B8156)',
    ];

    return fiveScaleBackgrounds[ratingIndex] ?? 'transparent';
};

export const Rating = styled.div<{
    $isSelected?: boolean;
    $hasAssessorSelection?: boolean;
    $ratingIndex?: number;
    $scaleSize?: number;
}>`
    display: flex;
    height: 44px;
    padding: 6px var(--spacing-sm, 16px);
    justify-content: center;
    align-items: center;
    gap: var(--spacing-2xs, 4px);
    flex: 1 0 0;
    color: ${({ $isSelected }) =>
        $isSelected ? 'var(--colors-text-on-action, #FFF)' : 'var(--colors-text-action, #2171c6)'};
    ${BODY_XS_XS_MEDIUM_STYLES};
    font-weight: ${({ $hasAssessorSelection }) => ($hasAssessorSelection ? 700 : 500)};
    border: ${({ $hasAssessorSelection }) =>
        $hasAssessorSelection
            ? 'var(--border-width-lg-4, 4px) solid rgba(33, 113, 198, 0.40)'
            : 'var(--border-width-sm_1, 1px) solid rgba(33, 113, 198, 0.4)'};
    border-radius: ${({ $hasAssessorSelection }) =>
        $hasAssessorSelection ? 'var(--border-radius-none, 0)' : undefined};
    background: ${({ $isSelected, $ratingIndex = 0, $scaleSize = 5 }) =>
        $isSelected ? getSelectedRatingBackground($scaleSize, $ratingIndex) : 'transparent'};
    cursor: pointer;

    &:first-child {
        border-radius: ${({ $hasAssessorSelection }) =>
            $hasAssessorSelection
                ? 'var(--border-radius-none, 0)'
                : 'var(--border-radius-s_8, 8px) 0 0 var(--border-radius-s_8, 8px)'};
    }

    &:last-child {
        border-radius: ${({ $hasAssessorSelection }) =>
            $hasAssessorSelection
                ? 'var(--border-radius-none, 0)'
                : '0 var(--border-radius-s_8, 8px) var(--border-radius-s_8, 8px) 0'};
    }
`;

export const Description = styled.div`
    color: var(--colors-text-body, #50566e);
    ${BODY_SM_SM_BOLD_STYLES};
`;

export const Guideline = styled.div`
    color: var(--colors-text-body, #50566e);
    ${BODY_SM_SM_STYLES};
    font-style: italic;
    margin-bottom: var(--spacing-xs, 8px);
`;

export const TasksWrapper = styled.div<{ $maxHeight?: number }>`
    display: flex;
    flex-direction: column;
    gap: 32px;
    ${({ $maxHeight }) =>
        $maxHeight !== undefined &&
        `
            max-height: ${$maxHeight}px;
            overflow-y: auto;
        `}
    scrollbar-width: thin;
    scrollbar-color: var(--colors-surface-action, #2171c6) var(--colors-border-primary, #e2e8f0);
`;

export const TaskWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

export const RatingsWrapper = styled.div`
    display: flex;

    .rating-element {
        background: var(--colors-surface-primary, #fff);
        color: var(--colors-text-action, #2171c6);
    }
`;

export const Title = styled.div`
    color: var(--colors-text-headings, #3e445c);
    ${BODY_LG_LG_MEDIUM_STYLES};
    padding-bottom: var(--spacing-sm, 16px);
    margin-top: var(--spacing-md, 24px);
`;
// task preview END
